module.exports = __webpack_public_path__ + "static/media/3DPPA21.80d9a925.jpg";